import * as Yup from 'yup';

export const ExternalClientMetadataCustomConfigSchema = Yup.object().shape({
  '@type': Yup.string(),
  id: Yup.string()
});
